import { AxiosError } from "axios";
import { Action } from "redux";

export enum PlannerActionTypes {
    PlannerItemCreated = "PLANNER_ITEM_CREATED",
    PlannerItemDeleted = "PLANNER_ITEM_DELETED",
    PlannerItemUpdated = "PLANNER_ITEM_UPDATED",

    PlannerFileAdded = "PLANNER_FILE_ADDED",
    PlannerFileRemoved = "PLANNER_FILE_REMOVED",

    FindPlannerItem = "FIND_PLANNER_ITEM",
    FindPlannerItemPending = "FIND_PLANNER_ITEM_PENDING",
    FindPlannerItemRejected = "FIND_PLANNER_ITEM_REJECTED",
    FindPlannerItemFulfilled = "FIND_PLANNER_ITEM_FULFILLED",

    QueryPlannerCategories = "QUERY_PLANNER_CATEGORIES",
    PlannerCategoryQueryPending = "PLANNER_CATEGORY_QUERY_PENDING",
    PlannerCategoryQueryRejected = "PLANNER_CATEGORY_QUERY_REJECTED",
    PlannerCategoryQueryFulfilled = "PLANNER_CATEGORY_QUERY_FULFILLED",

    QueryPlannerItems = "PLANNER_ITEM_QUERY",
    PlannerItemQueryPending = "PLANNER_ITEM_QUERY_PENDING",
    PlannerItemQueryRejected = "PLANNER_ITEM_QUERY_REJECTED",
    PlannerItemQueryFulfilled = "PLANNER_ITEM_QUERY_FULFILLED",

    QueryPlannerBoards = "PLANNER_BOARD_QUERY",
    PlannerBoardQueryPending = "PLANNER_BOARD_QUERY_PENDING",
    PlannerBoardQueryRejected = "PLANNER_BOARD_QUERY_REJECTED",
    PlannerBoardQueryFulfilled = "PLANNER_BOARD_QUERY_FULFILLED",
    
    PlannerBoardCreated = "PLANNER_BOARD_CREATED",
    PlannerBoardDeleted = "PLANNER_BOARD_DELETED",
    PlannerBoardUpdated = "PLANNER_BOARD_UPDATED",

    QueryPlannerLabels = "PLANNER_LABEL_QUERY",
    PlannerLabelQueryPending = "PLANNER_LABEL_QUERY_PENDING",
    PlannerLabelQueryRejected = "PLANNER_LABEL_QUERY_REJECTED",
    PlannerLabelQueryFulfilled = "PLANNER_LABEL_QUERY_FULFILLED",

    ToggleBoardIsHidden = "TOGGLE_BOARD_IS_HIDDEN",
    AppendPlannerItems = "APPEND_PLANNER_ITEMS",
};

export type PlannerItemCreatedAction = Action<PlannerActionTypes.PlannerItemCreated> & {
    item: Spintr.PlannerItem;
};

export type PlannerItemDeletedAction = Action<PlannerActionTypes.PlannerItemDeleted> & {
    id: number;
};

export type PlannerItemUpdatedAction = Action<PlannerActionTypes.PlannerItemUpdated> & {
    item: Spintr.PlannerItem;
};

export type PlannerFileAddedAction = Action<PlannerActionTypes.PlannerFileAdded> & {
    file: Spintr.PlannerItemFile;
};

export type PlannerFileRemovedAction = Action<PlannerActionTypes.PlannerFileRemoved> & {
    itemId: number;
    fileId: string;
};

export type FindPlannerItemAction = Action<PlannerActionTypes.FindPlannerItem> & {
    payload: Promise<Spintr.PlannerItem>;
};

export type FindPlannerItemPendingAction = Action<PlannerActionTypes.FindPlannerItemPending>;

export type FindPlannerItemRejectedAction = Action<PlannerActionTypes.FindPlannerItemRejected> & {
    error: true;
    payload: AxiosError;
};

export type FindPlannerItemFulfilledAction = Action<PlannerActionTypes.FindPlannerItemFulfilled> & {
    payload: Spintr.PlannerItem;
};

export type QueryPlannerCategoriesAction = Action<PlannerActionTypes.QueryPlannerCategories> & {
    payload: Promise<Spintr.QueryEnvelope<Spintr.PlannerItemCategory>>;
};

export type PlannerCategoryQueryPendingAction = Action<PlannerActionTypes.PlannerCategoryQueryPending>;

export type PlannerCategoryQueryRejectedAction = Action<PlannerActionTypes.PlannerCategoryQueryRejected> & {
    error: true;
    payload: AxiosError;
};

export type PlannerCategoryQueryFulfilledAction = Action<PlannerActionTypes.PlannerCategoryQueryFulfilled> & {
    payload: Spintr.QueryEnvelope<Spintr.PlannerItemCategory>;
};

export type QueryPlannerItemsAction = Action<PlannerActionTypes.QueryPlannerItems> & {
    payload: Promise<Spintr.QueryEnvelope<Spintr.PlannerItem>>;
};

export type PlannerItemQueryPendingAction = Action<PlannerActionTypes.PlannerItemQueryPending>;

export type PlannerItemQueryRejectedAction = Action<PlannerActionTypes.PlannerItemQueryRejected> & {
    error: true;
    payload: AxiosError;
};

export type PlannerItemQueryFulfilledAction = Action<PlannerActionTypes.PlannerItemQueryFulfilled> & {
    payload: Spintr.QueryEnvelope<Spintr.PlannerItem>;
};

export type QueryPlannerBoardsAction = Action<PlannerActionTypes.QueryPlannerBoards> & {
    payload: Promise<Spintr.PlannerBoard[]>;
};

export type PlannerBoardQueryPendingAction = Action<PlannerActionTypes.PlannerBoardQueryPending>;

export type PlannerBoardQueryRejectedAction = Action<PlannerActionTypes.PlannerBoardQueryRejected> & {
    error: true;
    payload: AxiosError;
};

export type PlannerBoardQueryFulfilledAction = Action<PlannerActionTypes.PlannerBoardQueryFulfilled> & {
    payload: Spintr.PlannerBoard[];
};

export type PlannerBoardCreatedAction = Action<PlannerActionTypes.PlannerBoardCreated> & {
    item: Spintr.PlannerBoard;
};

export type PlannerBoardDeletedAction = Action<PlannerActionTypes.PlannerBoardDeleted> & {
    id: number;
};

export type PlannerBoardUpdatedAction = Action<PlannerActionTypes.PlannerBoardUpdated> & {
    item: Spintr.PlannerBoard;
};

export type QueryPlannerLabelsAction = Action<PlannerActionTypes.QueryPlannerLabels> & {
    payload: Promise<Spintr.PlannerLabel[]>;
};

export type PlannerLabelQueryPendingAction = Action<PlannerActionTypes.PlannerLabelQueryPending>;

export type PlannerLabelQueryRejectedAction = Action<PlannerActionTypes.PlannerLabelQueryRejected> & {
    error: true;
    payload: AxiosError;
};

export type PlannerLabelQueryFulfilledAction = Action<PlannerActionTypes.PlannerLabelQueryFulfilled> & {
    payload: Spintr.PlannerLabel[];
};

export type ToggleBoardIsHiddenAction = Action<PlannerActionTypes.ToggleBoardIsHidden> & {
    boardId: number;
};

export type AppendPlannerItemsAction = Action<PlannerActionTypes.AppendPlannerItems> & {
    items: Spintr.PlannerItem[];
};

export type PlannerAction
    = PlannerItemCreatedAction
    | PlannerItemDeletedAction
    | PlannerItemUpdatedAction
    | PlannerFileAddedAction
    | PlannerFileRemovedAction
    | FindPlannerItemAction
    | FindPlannerItemPendingAction
    | FindPlannerItemRejectedAction
    | FindPlannerItemFulfilledAction   
    | QueryPlannerCategoriesAction
    | PlannerCategoryQueryPendingAction
    | PlannerCategoryQueryRejectedAction
    | PlannerCategoryQueryFulfilledAction 
    | QueryPlannerItemsAction
    | PlannerItemQueryPendingAction
    | PlannerItemQueryRejectedAction
    | PlannerItemQueryFulfilledAction
    | QueryPlannerBoardsAction
    | PlannerBoardQueryPendingAction
    | PlannerBoardQueryRejectedAction
    | PlannerBoardQueryFulfilledAction
    | PlannerBoardCreatedAction
    | PlannerBoardDeletedAction
    | PlannerBoardUpdatedAction
    | QueryPlannerLabelsAction
    | PlannerLabelQueryPendingAction
    | PlannerLabelQueryRejectedAction
    | PlannerLabelQueryFulfilledAction
    | ToggleBoardIsHiddenAction
    | AppendPlannerItemsAction;
